module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-login"
  }, [_c('div', {
    staticClass: " container-login"
  }, [_c('img', {
    staticClass: "icon-logo-big",
    attrs: {
      "src": require("../assets/image/logo.png")
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.checkLoginInfo($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group wrap-input"
  }, [_c('label', {
    attrs: {
      "for": "user-login-name"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userInfo.username),
      expression: "userInfo.username",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "user-login-name",
      "placeholder": "请输入您的邮箱号"
    },
    domProps: {
      "value": (_vm.userInfo.username)
    },
    on: {
      "keyup": function($event) {
        _vm.hideErrTip('name', _vm.userInfo.username)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "username", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.nameErr) ? _c('label', {
    staticClass: "show-error"
  }, [_vm._v(_vm._s(_vm.nameErrText))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group wrap-input"
  }, [_c('label', {
    attrs: {
      "for": "user-login-psw"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfo.password),
      expression: "userInfo.password"
    }],
    attrs: {
      "type": "password",
      "id": "user-login-psw",
      "placeholder": "请输入您的密码"
    },
    domProps: {
      "value": (_vm.userInfo.password)
    },
    on: {
      "keyup": function($event) {
        _vm.hideErrTip('psw', _vm.userInfo.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfo, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.pswErr) ? _c('label', {
    staticClass: "show-error"
  }, [_vm._v(_vm._s(_vm.pswErrText))]) : _vm._e()]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('z-lazyImg', {
    staticClass: "bg",
    attrs: {
      "placeImg": _vm.bg_small,
      "src": _vm.bg,
      "mask": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group "
  }, [_c('button', {
    staticClass: " btn-submit-login center-block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-a85a4258!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 781
// module chunks = 1